import axios from 'axios';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useMask } from '@react-input/mask';
import { ToastContainer, toast } from 'react-toastify';
// data
import { contactData, sotcialData } from '../../data/ContactData';
// components
import Head from '../../components/UI/Head/Head';
import Services from '../../components/Service/Services';
// style
import style from './contact.module.css';

const Contact = () => {
  const [buttonLoanding, setButtonLoanding] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [values, setValues] = useState({
    phone: '',
    name: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = 'hidden'; // Отключаем скролл при загрузке

    const timer = setTimeout(() => {
      setLoadingPage(false);
      document.body.style.overflow = 'visible'; // Возвращаем скролл после загрузки
    }, 300); // 1 секунда для имитации загрузки

    return () => {
      clearTimeout(timer);
      document.body.style.overflow = 'visible'; // На случай размонтирования компонента
    };
  }, []);

  const getInputData = (event, name) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const notify = () =>
    toast.success('Заявка успешно отправлена', {
      autoClose: 2000,
      position: 'top-left',
    });

  const notifyError = () =>
    toast.error('Сообщение не отправлено. Повторите попытку', {
      autoClose: 2000,
      position: 'top-left',
    });

  const notifyErrorPhone = () =>
    toast.error('Пожалуйста, введите полный номер телефона', {
      autoClose: 2000,
      position: 'top-left',
    });

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(values.phone)) {
      notifyErrorPhone();
      return;
    }

    const TOKEN = '7633057171:AAHtb-PpITvZyjzI8D6gZCH8pQ56ghiPJwU';
    const CHAT_ID = '-1002513052092';
    const URL_API = `https://api.telegram.org/bot${TOKEN}/sendMessage`;

    let message = `<b>Имя:</b> ${values.name}\n`;
    message += `<b>Телефон:</b> ${values.phone}\n`;

    setButtonLoanding(true);

    try {
      await axios.post(URL_API, {
        chat_id: CHAT_ID,
        parse_mode: 'html',
        text: message,
      });
      notify();
      setValues({ name: '', phone: '' });
      phoneRef.current?.setSelectionRange(0, 0);
      setButtonLoanding(false);
    } catch (error) {
      setButtonLoanding(false);
      notifyError();
    }
  };

  const phoneRef = useMask({
    mask: '+7 (___) ___-__-__',
    replacement: { _: /\d/ },
  });

  return (
    <>
      <Helmet>
        <title>Контакты — Sparta</title>
        <meta
          name="description"
          content="Свяжитесь с нами: +7-843-258-74-27, Пн - Вс 08:00 - 23:00."
        />
      </Helmet>
      {loadingPage ? (
        <div className="loaderWrapper">
          <div className="loaderPage"></div>
        </div>
      ) : (
        <main className={style.contact}>
          <Head url="/" />
          <div className="container">
            <div className="title-h1">
              <h1>Контакты</h1>
            </div>
            <div className={style.content}>
              <div className={style.left}>
                <iframe
                  src="https://yandex.ru/map-widget/v1/?um=constructor%3Ae216e6d46b9d269bec587bd9eb3686bfc25fcab6c2d0baf1a5691a879a955f67&amp;source=constructor"
                  frameBorder="0"
                  width="100%"
                  height="100%"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className={style.right}>
                <div className={style.container}>
                  <div className={style.right_items}>
                    <h3>Sparta</h3>
                    <ul className={style.contact_info}>
                      {contactData.map((item) => (
                        <li key={item.id}>
                          <span>{item.desc}: </span>
                          {item.url ? (
                            <a href={item.url}>{item.name}</a>
                          ) : (
                            <span>{item.name}</span>
                          )}
                        </li>
                      ))}
                    </ul>
                    <div className={style.sotcial}>
                      <div className={style.sotsial_title}>Соц. сети:</div>
                      <div className={style.sot_icons}>
                        <ul>
                          {sotcialData.map((item) => (
                            <li key={item.id}>
                              <a href={item.url} target="_blank">
                                {item.icon}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <hr />
                    <h3>Заказать звонок</h3>
                    <span className={style.span}>
                      Наш менеджер перезвонит вам
                    </span>
                    <div className={style.form_content}>
                      <form onSubmit={onSubmit}>
                        <div className={style.input_box}>
                          <input
                            type="text"
                            name="имя"
                            placeholder="Ваше имя"
                            onChange={(e) => getInputData(e, 'name')}
                            required
                            value={values.name}
                            minLength="3"
                          />
                          <input
                            type="tel"
                            name="Телефон"
                            value={values.phone}
                            ref={phoneRef}
                            onChange={(e) => getInputData(e, 'phone')}
                            placeholder="+7(___)___-__-__"
                            required
                          />
                          <button type="submit" disabled={buttonLoanding}>
                            {!buttonLoanding ? (
                              'Отправить'
                            ) : (
                              <div className="send-lounding"></div>
                            )}
                          </button>
                        </div>
                        <div className={style.lega}>
                          <span>
                            Нажимая «Отправить», я даю согласие на обработку{' '}
                            <Link to="/privacy">персональных данных</Link>.
                          </span>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Services />
          <ToastContainer />
        </main>
      )}
    </>
  );
};
export default Contact;
